import { render, staticRenderFns } from "./page-drawer-factory.vue?vue&type=template&id=5a816ac9&scoped=true"
import script from "./page-drawer-factory.vue?vue&type=script&lang=js"
export * from "./page-drawer-factory.vue?vue&type=script&lang=js"
import style0 from "./page-drawer-factory.vue?vue&type=style&index=0&id=5a816ac9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a816ac9",
  null
  
)

export default component.exports